import Vue from 'vue';
import VueI18n from 'vue-i18n';
// import store from '../store/store';

Vue.use(VueI18n);

// const locale =
//   localStorage.getItem("langOption") !== null
//     ? localStorage.getItem("langOption")
//     : "it";

// const messages = {
//   en: {},
//   es: {},
//   it: {}
// };

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {}
});

export default i18n;
